export function scrollToPosition(
  position: 'top' | 'bottom',
  behavior: 'smooth' | 'instant',
  element?: HTMLElement
): void {
  if (!element) {
    return;
  }

  const top = position === 'top' ? 0 : element.scrollHeight;

  element.scrollTo({
    top,
    behavior,
  });
}
